import { fetchBidderCardStatusIfNeeded } from './bidderCardStatus';
import { fetchBidderPreferencesIfNeeded } from './bidderPreference';
import { fetchCertificatesIfNeeded } from './certCapture';
import { fetchConversationFoldersIfNeeded } from './conversationFolders';
import { fetchLAPaymentCardIfNeeded } from './creditCard';
import { fetchNotificationsIfNeeded } from './notification';
import { fetchSavedSearchesIfNeeded } from './savedSearch';
import { fetchSmsAlertsIfNeeded } from './smsAlerts';
import { fetchWonItemsCountIfNeeded } from './wonItemsCount/wonItemsCount.actions';
import ResellerTypes from '@/enums/resellerTypes';

export const loadBidderData = (resellerType: number) => async (dispatch: Function) => {
    const bidderDataCalls = [
        dispatch(fetchConversationFoldersIfNeeded()),
        dispatch(fetchSmsAlertsIfNeeded()),
        dispatch(fetchLAPaymentCardIfNeeded()),
        dispatch(fetchBidderCardStatusIfNeeded()),
        dispatch(fetchBidderPreferencesIfNeeded()),
        dispatch(fetchNotificationsIfNeeded(true)),
        dispatch(fetchWonItemsCountIfNeeded()),
        dispatch(fetchSavedSearchesIfNeeded()),
    ];

    if (resellerType === ResellerTypes.RESELLER) {
        bidderDataCalls.push(dispatch(fetchCertificatesIfNeeded()));
    }
    await Promise.all(bidderDataCalls);
};
